<div class="search-select list-search-container {{classes}}" (window:click)="handleClick($event)">
    <div class="content list-search-container flex-grow-1">
        <span *ngIf="_selected && !isOpen && !hideSelected">{{_selected.label}}</span>
        <input
            *ngIf="!simpleList"
            [id]="prefix"
            type="text"
            placeholder="{{htmlToText(_selected?.label ? (hideSelected ? placeholder : '') : placeholder)}}"
            class="form-control list-search-input"
            (focus)="focusInput()"
            [(ngModel)]="filter.searchFilter"
            autocomplete="off"/>
        <input
            *ngIf="simpleList"
            [id]="prefix"
            type="text"
            placeholder="{{htmlToText(_selected?.label ? (hideSelected ? placeholder : '') : placeholder)}}"
            class="form-control list-search-input"
            (focus)="focusInput()"
            [(ngModel)]="filter"
            autocomplete="off"/>
        <i
            *ngIf="(filter && (simpleList ? filter.length : filter.searchFilter.length)) || (_selected && ((_selected['prop'] && _selected['prop'].length) || (_selected.label && _selected.label.length)))"
            (click)="resetSelectSearch()"
            class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2 {{showAdd ? 'not-last' : ''}}"></i>
        <button *ngIf="showAdd"
            class="btn btn-sm btn-primary mr-1"
            (click)="$event.preventDefault(); $event.stopPropagation(); addFunction.emit();">{{ "Add" | translate }}</button>
    </div>
    <div *ngIf="items && items.length"
        [ngClass]="{'o': isOpen}"
        class="items flex-column">
        <div class="item w-100 d-flex flex-grow-1"
            *ngFor="let item of items | filterBy: filter"
            (click)="selectItem(item);">
            <span [innerHTML]="(item.fullName ? item.fullName : (item.name ? item.name : (item.label ? item.label : (item.value ? item.value : item))))" ></span>
            <a *ngIf="showEdit"
            class="btn list-search-add ml-auto btn-dark"
            (click)="$event.preventDefault(); $event.stopPropagation(); editFunction.emit(item);">{{ "Edit" | translate }}</a>
        </div>
    </div>
</div>
